export default function PrivacyContent() {
  return (
    <div className="pt-20 lg:pt-32 pb-12 lg:pb-20 px-4 lg:px-12">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8 lg:mb-16 text-center">
          <h1 className="text-2xl lg:text-5xl font-bold text-slate-900 mb-3 lg:mb-6">
            Politique de Confidentialité
          </h1>
          <p className="text-slate-600 text-sm lg:text-lg">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </div>

        {/* Introduction */}
        <div className="mb-6 lg:mb-12 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl lg:rounded-2xl p-4 lg:p-8 border border-emerald-100">
          <div className="flex items-start gap-3 lg:gap-4">
            <div className="w-8 h-8 lg:w-12 lg:h-12 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white flex-shrink-0">
              <i className="ri-shield-check-line text-base lg:text-xl"></i>
            </div>
            <div>
              <h2 className="text-base lg:text-xl font-bold text-slate-900 mb-2 lg:mb-3">Votre vie privée est notre priorité</h2>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                POWERENO s'engage à protéger et respecter votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons, partageons et protégons vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-6 lg:space-y-12">
          {/* Section 1 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-information-line text-sm lg:text-lg"></i>
              </span>
              Identité du responsable du traitement
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-3 lg:space-y-4">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                <strong className="text-slate-900">Responsable du traitement :</strong> POWERENO
              </p>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                <strong className="text-slate-900">Forme juridique :</strong> SAS (Société par Actions Simplifiée)
              </p>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                <strong className="text-slate-900">Adresse :</strong> 37 rue d'Amsterdam, 75008 Paris
              </p>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                <strong className="text-slate-900">SIRET :</strong> 893 407 031
              </p>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                <strong className="text-slate-900">Email :</strong> contact@powereno.fr
              </p>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                <strong className="text-slate-900">Directeur de la publication :</strong> Charbit Daniel, Dirigeant
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-database-2-line text-sm lg:text-lg"></i>
              </span>
              Données personnelles collectées
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-4 lg:space-y-6">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Nous collectons les données personnelles suivantes :
              </p>
              
              <div className="space-y-3 lg:space-y-6">
                <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 lg:mb-3 flex items-center gap-2">
                    <i className="ri-user-line text-emerald-500"></i>
                    Données d'identification
                  </h3>
                  <ul className="list-disc list-inside space-y-1 lg:space-y-2 text-slate-700 text-sm lg:text-base ml-4 lg:ml-6">
                    <li>Nom et prénom</li>
                    <li>Raison sociale de l'entreprise</li>
                    <li>Fonction ou poste occupé</li>
                  </ul>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 lg:mb-3 flex items-center gap-2">
                    <i className="ri-mail-line text-emerald-500"></i>
                    Données de contact
                  </h3>
                  <ul className="list-disc list-inside space-y-1 lg:space-y-2 text-slate-700 text-sm lg:text-base ml-4 lg:ml-6">
                    <li>Adresse email professionnelle</li>
                    <li>Numéro de téléphone</li>
                    <li>Adresse postale de l'entreprise</li>
                  </ul>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 lg:mb-3 flex items-center gap-2">
                    <i className="ri-building-line text-emerald-500"></i>
                    Données relatives au projet
                  </h3>
                  <ul className="list-disc list-inside space-y-1 lg:space-y-2 text-slate-700 text-sm lg:text-base ml-4 lg:ml-6">
                    <li>Type de bâtiment et surface</li>
                    <li>Besoins en rénovation LED</li>
                    <li>Budget estimé</li>
                    <li>Délais souhaités</li>
                  </ul>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 lg:mb-3 flex items-center gap-2">
                    <i className="ri-computer-line text-emerald-500"></i>
                    Données de navigation
                  </h3>
                  <ul className="list-disc list-inside space-y-1 lg:space-y-2 text-slate-700 text-sm lg:text-base ml-4 lg:ml-6">
                    <li>Adresse IP</li>
                    <li>Type de navigateur et système d'exploitation</li>
                    <li>Pages visitées et durée de visite</li>
                    <li>Source de référencement</li>
                  </ul>
                  <div className="mt-3 lg:mt-4 bg-blue-50 rounded-lg p-3 lg:p-4 border border-blue-200">
                    <p className="text-xs lg:text-sm text-slate-700">
                      <i className="ri-information-line text-blue-500 mr-2"></i>
                      Pour plus d'informations sur les cookies et traceurs, consultez notre <a href="/politique-des-cookies" className="text-emerald-600 hover:underline font-semibold cursor-pointer">Politique de Cookies</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-target-line text-sm lg:text-lg"></i>
              </span>
              Finalités et bases légales du traitement
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-4 lg:space-y-6">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Vos données personnelles sont collectées et traitées pour les finalités suivantes :
              </p>

              <div className="space-y-3 lg:space-y-4">
                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Gestion des demandes de contact et devis</h3>
                  <p className="text-slate-700 text-xs lg:text-sm mb-2">
                    <strong>Base légale :</strong> Exécution de mesures précontractuelles prises à votre demande (Article 6.1.b du RGPD)
                  </p>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    <strong>Durée de conservation :</strong> 3 ans à compter du dernier contact
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Réalisation d'études gratuites et audits énergétiques</h3>
                  <p className="text-slate-700 text-xs lg:text-sm mb-2">
                    <strong>Base légale :</strong> Exécution de mesures précontractuelles (Article 6.1.b du RGPD)
                  </p>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    <strong>Durée de conservation :</strong> 3 ans à compter de la réalisation de l'étude
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Gestion de la relation client et exécution des contrats</h3>
                  <p className="text-slate-700 text-xs lg:text-sm mb-2">
                    <strong>Base légale :</strong> Exécution du contrat (Article 6.1.b du RGPD)
                  </p>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    <strong>Durée de conservation :</strong> Durée du contrat + 10 ans (garantie décennale)
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Constitution et gestion des dossiers CEE</h3>
                  <p className="text-slate-700 text-xs lg:text-sm mb-2">
                    <strong>Base légale :</strong> Obligation légale (Article 6.1.c du RGPD)
                  </p>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    <strong>Durée de conservation :</strong> Durée légale de conservation des documents CEE (5 ans minimum)
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Envoi de communications marketing (newsletter, offres)</h3>
                  <p className="text-slate-700 text-xs lg:text-sm mb-2">
                    <strong>Base légale :</strong> Consentement (Article 6.1.a du RGPD) ou intérêt légitime pour les clients existants
                  </p>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    <strong>Durée de conservation :</strong> 3 ans à compter du dernier contact ou jusqu'au retrait du consentement
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Amélioration de nos services et analyse statistique</h3>
                  <p className="text-slate-700 text-xs lg:text-sm mb-2">
                    <strong>Base légale :</strong> Intérêt légitime (Article 6.1.f du RGPD)
                  </p>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    <strong>Durée de conservation :</strong> 25 mois pour les données de navigation
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Respect des obligations légales et réglementaires</h3>
                  <p className="text-slate-700 text-xs lg:text-sm mb-2">
                    <strong>Base légale :</strong> Obligation légale (Article 6.1.c du RGPD)
                  </p>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    <strong>Durée de conservation :</strong> Selon les obligations légales applicables (comptabilité : 10 ans, fiscalité : 6 ans)
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-share-line text-sm lg:text-lg"></i>
              </span>
              Destinataires des données
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-4 lg:space-y-6">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Vos données personnelles sont destinées aux catégories de destinataires suivantes :
              </p>

              <ul className="space-y-3 lg:space-y-4">
                <li className="flex items-start gap-2 lg:gap-3">
                  <i className="ri-checkbox-circle-fill text-emerald-500 text-lg lg:text-xl mt-1"></i>
                  <div className="text-sm lg:text-base">
                    <strong className="text-slate-900">Personnel autorisé de POWERENO :</strong>
                    <span className="text-slate-700"> Services commercial, technique, administratif et comptable</span>
                  </div>
                </li>
                <li className="flex items-start gap-2 lg:gap-3">
                  <i className="ri-checkbox-circle-fill text-emerald-500 text-lg lg:text-xl mt-1"></i>
                  <div className="text-sm lg:text-base">
                    <strong className="text-slate-900">Sous-traitants :</strong>
                    <span className="text-slate-700"> Hébergeur du site web (IONOS), prestataires de services informatiques, outils de gestion de la relation client (CRM)</span>
                  </div>
                </li>
                <li className="flex items-start gap-2 lg:gap-3">
                  <i className="ri-checkbox-circle-fill text-emerald-500 text-lg lg:text-xl mt-1"></i>
                  <div className="text-sm lg:text-base">
                    <strong className="text-slate-900">Organismes CEE :</strong>
                    <span className="text-slate-700"> Pour la constitution et le traitement des dossiers de Certificats d'Économies d'Énergie</span>
                  </div>
                </li>
                <li className="flex items-start gap-2 lg:gap-3">
                  <i className="ri-checkbox-circle-fill text-emerald-500 text-lg lg:text-xl mt-1"></i>
                  <div className="text-sm lg:text-base">
                    <strong className="text-slate-900">Autorités compétentes :</strong>
                    <span className="text-slate-700"> En cas d'obligation légale ou de demande judiciaire</span>
                  </div>
                </li>
              </ul>

              <div className="bg-emerald-50 rounded-lg p-4 lg:p-6 border border-emerald-200 mt-4 lg:mt-6">
                <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                  <i className="ri-shield-check-line text-emerald-600 mr-2"></i>
                  <strong className="text-slate-900">Engagement :</strong> Nous ne vendons, ne louons ni ne transmettons vos données personnelles à des tiers à des fins commerciales sans votre consentement explicite.
                </p>
              </div>
            </div>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-global-line text-sm lg:text-lg"></i>
              </span>
              Transferts de données hors UE
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-4 lg:space-y-6">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Vos données personnelles sont hébergées et traitées au sein de l'Union Européenne.
              </p>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Dans le cas où certains de nos prestataires seraient situés hors de l'Union Européenne, nous nous assurons que :
              </p>
              <ul className="list-disc list-inside space-y-1 lg:space-y-2 text-slate-700 text-sm lg:text-base ml-4 lg:ml-6">
                <li>Le pays bénéficie d'une décision d'adéquation de la Commission Européenne</li>
                <li>Ou que des garanties appropriées sont mises en place (clauses contractuelles types de la Commission Européenne, règles d'entreprise contraignantes, etc.)</li>
                <li>Ou que votre consentement explicite a été obtenu</li>
              </ul>
            </div>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-lock-line text-sm lg:text-lg"></i>
              </span>
              Sécurité des données
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-4 lg:space-y-6">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour garantir la sécurité de vos données personnelles et les protéger contre toute destruction, perte, altération, divulgation ou accès non autorisé :
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 lg:gap-4">
                <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                  <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-lg bg-emerald-100 text-emerald-600 mb-3 lg:mb-4">
                    <i className="ri-shield-keyhole-line text-lg lg:text-xl"></i>
                  </div>
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Chiffrement SSL/TLS</h3>
                  <p className="text-slate-700 text-xs lg:text-sm">Toutes les données transitent via des connexions sécurisées HTTPS</p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                  <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-lg bg-emerald-100 text-emerald-600 mb-3 lg:mb-4">
                    <i className="ri-key-line text-lg lg:text-xl"></i>
                  </div>
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Contrôle d'accès</h3>
                  <p className="text-slate-700 text-xs lg:text-sm">Accès limité aux seules personnes autorisées avec authentification forte</p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                  <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-lg bg-emerald-100 text-emerald-600 mb-3 lg:mb-4">
                    <i className="ri-server-line text-lg lg:text-xl"></i>
                  </div>
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Hébergement sécurisé</h3>
                  <p className="text-slate-700 text-xs lg:text-sm">Serveurs hébergés dans des datacenters certifiés en France/UE</p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                  <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-lg bg-emerald-100 text-emerald-600 mb-3 lg:mb-4">
                    <i className="ri-save-line text-lg lg:text-xl"></i>
                  </div>
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Sauvegardes régulières</h3>
                  <p className="text-slate-700 text-xs lg:text-sm">Sauvegardes automatiques et chiffrées de vos données</p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                  <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-lg bg-emerald-100 text-emerald-600 mb-3 lg:mb-4">
                    <i className="ri-shield-check-line text-lg lg:text-xl"></i>
                  </div>
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Pare-feu et antivirus</h3>
                  <p className="text-slate-700 text-xs lg:text-sm">Protection contre les intrusions et les logiciels malveillants</p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                  <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center rounded-lg bg-emerald-100 text-emerald-600 mb-3 lg:mb-4">
                    <i className="ri-user-settings-line text-lg lg:text-xl"></i>
                  </div>
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2">Formation du personnel</h3>
                  <p className="text-slate-700 text-xs lg:text-sm">Sensibilisation régulière à la protection des données</p>
                </div>
              </div>
            </div>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-hand-heart-line text-sm lg:text-lg"></i>
              </span>
              Vos droits sur vos données
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-4 lg:space-y-6">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants sur vos données personnelles :
              </p>

              <div className="space-y-3 lg:space-y-4">
                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 flex items-center gap-2">
                    <i className="ri-eye-line text-emerald-500"></i>
                    Droit d'accès (Article 15 RGPD)
                  </h3>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    Vous pouvez obtenir la confirmation que vos données sont traitées et accéder à ces données ainsi qu'à certaines informations sur le traitement.
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 flex items-center gap-2">
                    <i className="ri-edit-line text-emerald-500"></i>
                    Droit de rectification (Article 16 RGPD)
                  </h3>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    Vous pouvez obtenir la rectification de vos données inexactes ou incomplètes.
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 flex items-center gap-2">
                    <i className="ri-delete-bin-line text-emerald-500"></i>
                    Droit à l'effacement (Article 17 RGPD)
                  </h3>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    Vous pouvez obtenir l'effacement de vos données dans certains cas (retrait du consentement, données non nécessaires, opposition au traitement, etc.).
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 flex items-center gap-2">
                    <i className="ri-pause-circle-line text-emerald-500"></i>
                    Droit à la limitation du traitement (Article 18 RGPD)
                  </h3>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    Vous pouvez obtenir la limitation du traitement de vos données dans certaines circonstances.
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 flex items-center gap-2">
                    <i className="ri-download-line text-emerald-500"></i>
                    Droit à la portabilité (Article 20 RGPD)
                  </h3>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    Vous pouvez recevoir vos données dans un format structuré et couramment utilisé, et les transmettre à un autre responsable de traitement.
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 flex items-center gap-2">
                    <i className="ri-close-circle-line text-emerald-500"></i>
                    Droit d'opposition (Article 21 RGPD)
                  </h3>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    Vous pouvez vous opposer au traitement de vos données pour des raisons tenant à votre situation particulière ou à des fins de prospection commerciale.
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 flex items-center gap-2">
                    <i className="ri-user-unfollow-line text-emerald-500"></i>
                    Droit de retirer votre consentement
                  </h3>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    Lorsque le traitement est fondé sur votre consentement, vous pouvez le retirer à tout moment sans affecter la licéité du traitement effectué avant le retrait.
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 lg:p-6 border-l-4 border-emerald-500">
                  <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-2 flex items-center gap-2">
                    <i className="ri-file-list-line text-emerald-500"></i>
                    Droit de définir des directives post-mortem
                  </h3>
                  <p className="text-slate-700 text-xs lg:text-sm">
                    Vous pouvez définir des directives relatives au sort de vos données après votre décès.
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-lg p-4 lg:p-6 border border-emerald-200 mt-6 lg:mt-8">
                <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-3 lg:mb-4 flex items-center gap-2">
                  <i className="ri-question-line text-emerald-600"></i>
                  Comment exercer vos droits ?
                </h3>
                <p className="text-slate-700 text-sm lg:text-base mb-3 lg:mb-4">
                  Pour exercer l'un de ces droits, vous pouvez nous contacter :
                </p>
                <ul className="space-y-2 text-slate-700 text-sm lg:text-base">
                  <li className="flex items-center gap-2">
                    <i className="ri-mail-line text-emerald-500"></i>
                    Par email : <strong>contact@powereno.fr</strong>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-mail-send-line text-emerald-500"></i>
                    Par courrier : <strong>POWERENO - 37 rue d'Amsterdam, 75008 Paris</strong>
                  </li>
                </ul>
                <p className="text-slate-700 mt-3 lg:mt-4 text-xs lg:text-sm">
                  Nous nous engageons à répondre à votre demande dans un délai d'un mois à compter de sa réception. Ce délai peut être prolongé de deux mois en cas de complexité de la demande.
                </p>
              </div>
            </div>
          </section>

          {/* Section 8 - Cookies simplifié avec renvoi */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-cookie-line text-sm lg:text-lg"></i>
              </span>
              Cookies et traceurs
            </h2>
            <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-lg lg:rounded-xl p-4 lg:p-8 border border-emerald-200">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed mb-4 lg:mb-6">
                Notre site utilise des cookies et autres traceurs pour améliorer votre expérience de navigation, analyser l'utilisation du site et personnaliser le contenu.
              </p>

              <div className="bg-white rounded-lg p-4 lg:p-6 mb-4 lg:mb-6">
                <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-3">Types de cookies utilisés :</h3>
                <ul className="space-y-2 text-slate-700 text-sm lg:text-base">
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-emerald-500 mt-1"></i>
                    <span><strong>Cookies nécessaires :</strong> Indispensables au fonctionnement du site</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-emerald-500 mt-1"></i>
                    <span><strong>Cookies analytiques :</strong> Mesure d'audience et statistiques (Google Analytics)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-emerald-500 mt-1"></i>
                    <span><strong>Cookies de personnalisation :</strong> Mémorisation de vos préférences</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-emerald-500 mt-1"></i>
                    <span><strong>Cookies publicitaires :</strong> Publicités ciblées (avec votre consentement)</span>
                  </li>
                </ul>
              </div>

              <a 
                href="/politique-des-cookies"
                className="bg-white rounded-lg p-4 lg:p-6 border-2 border-emerald-500 hover:bg-emerald-50 transition-all cursor-pointer group flex items-center justify-between"
              >
                <div className="flex items-center gap-3 lg:gap-4">
                  <div className="w-10 h-10 lg:w-14 lg:h-14 flex items-center justify-center rounded-lg bg-emerald-100 text-emerald-600 group-hover:bg-emerald-500 group-hover:text-white transition-colors">
                    <i className="ri-settings-3-line text-lg lg:text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-1">Gérer vos préférences cookies</h3>
                    <p className="text-slate-700 text-xs lg:text-sm">
                      Consultez notre politique complète et personnalisez vos choix
                    </p>
                  </div>
                </div>
                <i className="ri-arrow-right-line text-xl lg:text-2xl text-emerald-600 group-hover:translate-x-2 transition-transform"></i>
              </a>
            </div>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-time-line text-sm lg:text-lg"></i>
              </span>
              Durées de conservation
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-4">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed mb-4 lg:mb-6">
                Vos données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées :
              </p>

              <div className="overflow-x-auto -mx-4 lg:mx-0">
                <table className="w-full bg-white rounded-lg overflow-hidden">
                  <thead className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                    <tr>
                      <th className="px-3 lg:px-6 py-3 lg:py-4 text-left font-semibold text-xs lg:text-base">Type de données</th>
                      <th className="px-3 lg:px-6 py-3 lg:py-4 text-left font-semibold text-xs lg:text-base">Durée de conservation</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200">
                    <tr>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">Demandes de contact/devis (prospects)</td>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">3 ans à compter du dernier contact</td>
                    </tr>
                    <tr className="bg-slate-50">
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">Données clients (contrats en cours)</td>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">Durée du contrat + 10 ans (garantie décennale)</td>
                    </tr>
                    <tr>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">Données comptables</td>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">10 ans à compter de la clôture de l'exercice</td>
                    </tr>
                    <tr className="bg-slate-50">
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">Données fiscales</td>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">6 ans à compter de la clôture de l'exercice</td>
                    </tr>
                    <tr>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">Dossiers CEE</td>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">5 ans minimum (durée légale de conservation des CEE)</td>
                    </tr>
                    <tr className="bg-slate-50">
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">Données de navigation (cookies)</td>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">25 mois maximum</td>
                    </tr>
                    <tr>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">Listes d'opposition (démarchage)</td>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">3 ans</td>
                    </tr>
                    <tr className="bg-slate-50">
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">Données de vidéosurveillance (si applicable)</td>
                      <td className="px-3 lg:px-6 py-3 lg:py-4 text-slate-700 text-xs lg:text-base">1 mois maximum</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="text-slate-700 text-xs lg:text-sm mt-4 lg:mt-6">
                À l'issue de ces durées, vos données sont supprimées ou anonymisées de manière irréversible.
              </p>
            </div>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-parent-line text-sm lg:text-lg"></i>
              </span>
              Protection des mineurs
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-3 lg:space-y-4">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Notre site et nos services s'adressent exclusivement aux professionnels et aux entreprises. Nous ne collectons pas sciemment de données personnelles concernant des mineurs de moins de 16 ans.
              </p>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Si nous apprenons qu'un mineur a fourni des données personnelles, nous prendrons des mesures pour supprimer ces informations dans les plus brefs délais.
              </p>
            </div>
          </section>

          {/* Section 11 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-alert-line text-sm lg:text-lg"></i>
              </span>
              Violation de données
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-3 lg:space-y-4">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                En cas de violation de données personnelles susceptible d'engendrer un risque élevé pour vos droits et libertés, nous nous engageons à :
              </p>
              <ul className="list-disc list-inside space-y-1 lg:space-y-2 text-slate-700 text-sm lg:text-base ml-4 lg:ml-6">
                <li>Notifier la CNIL dans les 72 heures suivant la découverte de la violation</li>
                <li>Vous informer dans les meilleurs délais si la violation est susceptible d'engendrer un risque élevé pour vos droits et libertés</li>
                <li>Mettre en œuvre toutes les mesures nécessaires pour remédier à la violation et en limiter les conséquences</li>
              </ul>
            </div>
          </section>

          {/* Section 12 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-scales-3-line text-sm lg:text-lg"></i>
              </span>
              Réclamation auprès de la CNIL
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-4 lg:space-y-6">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Si vous estimez que vos droits ne sont pas respectés ou que le traitement de vos données personnelles n'est pas conforme à la réglementation, vous disposez du droit d'introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL).
              </p>

              <div className="bg-white rounded-lg p-4 lg:p-6 border border-slate-200">
                <h3 className="font-bold text-slate-900 text-sm lg:text-base mb-3 lg:mb-4 flex items-center gap-2">
                  <i className="ri-government-line text-emerald-500"></i>
                  Coordonnées de la CNIL
                </h3>
                <ul className="space-y-2 lg:space-y-3 text-slate-700 text-sm lg:text-base">
                  <li className="flex items-start gap-2 lg:gap-3">
                    <i className="ri-map-pin-line text-emerald-500 mt-1"></i>
                    <div>
                      <strong>Adresse postale :</strong><br />
                      Commission Nationale de l'Informatique et des Libertés<br />
                      3 Place de Fontenoy<br />
                      TSA 80715<br />
                      75334 PARIS CEDEX 07
                    </div>
                  </li>
                  <li className="flex items-center gap-2 lg:gap-3">
                    <i className="ri-phone-line text-emerald-500"></i>
                    <div>
                      <strong>Téléphone :</strong> 01 53 73 22 22
                    </div>
                  </li>
                  <li className="flex items-center gap-2 lg:gap-3">
                    <i className="ri-global-line text-emerald-500"></i>
                    <div>
                      <strong>Site web :</strong> <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:underline cursor-pointer">www.cnil.fr</a>
                    </div>
                  </li>
                  <li className="flex items-center gap-2 lg:gap-3">
                    <i className="ri-file-text-line text-emerald-500"></i>
                    <div>
                      <strong>Formulaire en ligne :</strong> <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:underline cursor-pointer">www.cnil.fr/fr/plaintes</a>
                    </div>
                  </li>
                </ul>
              </div>

              <p className="text-slate-700 text-xs lg:text-sm">
                Nous vous encourageons toutefois à nous contacter en premier lieu afin que nous puissions traiter votre demande dans les meilleurs délais.
              </p>
            </div>
          </section>

          {/* Section 13 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-refresh-line text-sm lg:text-lg"></i>
              </span>
              Modifications de la politique de confidentialité
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-3 lg:space-y-4">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment, notamment pour nous conformer à toute évolution réglementaire, jurisprudentielle, éditoriale ou technique.
              </p>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                En cas de modification substantielle, nous vous en informerons par tout moyen approprié (notification sur le site, email, etc.).
              </p>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                La date de dernière mise à jour est indiquée en haut de cette page. Nous vous invitons à consulter régulièrement cette politique pour prendre connaissance des éventuelles modifications.
              </p>
            </div>
          </section>

          {/* Section 14 */}
          <section>
            <h2 className="text-lg lg:text-2xl font-bold text-slate-900 mb-3 lg:mb-6 flex items-center gap-2 lg:gap-3">
              <span className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                <i className="ri-file-list-3-line text-sm lg:text-lg"></i>
              </span>
              Droit applicable
            </h2>
            <div className="bg-slate-50 rounded-lg lg:rounded-xl p-4 lg:p-8 space-y-3 lg:space-y-4">
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                La présente politique de confidentialité est régie par le droit français. Elle est rédigée en langue française et conforme au Règlement Général sur la Protection des Données (RGPD - Règlement UE 2016/679) et à la loi Informatique et Libertés du 6 janvier 1978 modifiée.
              </p>
              <p className="text-slate-700 text-sm lg:text-base leading-relaxed">
                En cas de litige relatif à l'interprétation ou à l'exécution de la présente politique, et à défaut d'accord amiable, les tribunaux français seront seuls compétents.
              </p>
            </div>
          </section>
        </div>

        {/* Contact CTA */}
        <div className="mt-10 lg:mt-16 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-xl lg:rounded-2xl p-6 lg:p-10 text-center text-white">
          <div className="w-12 h-12 lg:w-16 lg:h-16 flex items-center justify-center rounded-full bg-white/20 mx-auto mb-4 lg:mb-6">
            <i className="ri-customer-service-2-line text-2xl lg:text-3xl"></i>
          </div>
          <h3 className="text-xl lg:text-2xl font-bold mb-3 lg:mb-4">Des questions sur vos données personnelles ?</h3>
          <p className="text-white/90 text-sm lg:text-base mb-6 lg:mb-8 max-w-2xl mx-auto">
            Notre équipe est à votre écoute pour répondre à toutes vos questions concernant la protection de vos données et l'exercice de vos droits.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 lg:gap-4 justify-center">
            <a 
              href="mailto:contact@powereno.fr"
              className="inline-flex items-center justify-center gap-2 bg-white text-emerald-600 px-6 lg:px-8 py-3 lg:py-4 rounded-full font-semibold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap text-sm lg:text-base"
            >
              <i className="ri-mail-send-line text-lg lg:text-xl"></i>
              Nous contacter par email
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
